<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'dokumen-pod',
};
</script>

<style>
</style>
